import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { CurrentUser } from "../../common/providers/current-user";
import { ActivatedRoute } from '@angular/router';
import { DiscussionService } from '../../chat/discussion/discussion.service';
import { Subscription } from 'rxjs';
import { Organization } from "../../common/models/organization";
import { User } from "../../common/models/user";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { DiscussionListComponent } from "../../chat/discussion/discussion-list.component";

@Component({
  selector: 'app-mobile-chat',
  providers: [],
  styleUrls: ['./mobile.chat.component.scss'],
  standalone: true,
  imports: [
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    DiscussionListComponent
  ],
  templateUrl: './mobile.chat.component.html'
})
export class MobileChatComponent implements OnInit, OnDestroy, AfterViewInit {
    public pageTitle = 'Mobile.dashboard';
    public isLoading = true;
    public is401 = false;
    public is404 = false;
    public dashboardUrl: string | null = null;
    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;

    @ViewChild('discussionMobileRef', { static: true, read: ViewContainerRef })
    public discussionRefs: ViewContainerRef = {} as ViewContainerRef;

    private subscriptions: Subscription[] = [];

    constructor(
        public currentUser: CurrentUser,
        private route: ActivatedRoute,
        private discussionService: DiscussionService
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //  { organization: Organization; athlete: Athlete }
                this.organization = data.organization;
                this.athleteUser = data.athlete;
                this.dashboardUrl = data.organization.code + '/app/athletes/' + data.athlete.id;

            })
        );

        const body = document.getElementsByTagName('body')[0];
        body.classList.add('mobile');

    }

    public ngAfterViewInit(): void {
        this.discussionService.populateDiscussionsEvent.emit();
    }

    public getChatDiscussionRef() {
        return this.discussionRefs;
    }

    public ngOnDestroy(): void {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('mobile');
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
